var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArroRightGo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow.right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow.right_2",
    d: "M22.3145 13.6445C22.3145 13.3721 22.2002 13.1084 21.998 12.915L16.2236 7.14062C15.9951 6.9209 15.7578 6.82422 15.5117 6.82422C14.9492 6.82422 14.5449 7.21973 14.5449 7.75586C14.5449 8.03711 14.6592 8.27441 14.835 8.4502L16.8125 10.4541L19.3613 12.7832L17.3223 12.6602H6.66992C6.08105 12.6602 5.67676 13.0645 5.67676 13.6445C5.67676 14.2158 6.08105 14.6201 6.66992 14.6201H17.3223L19.3613 14.4971L16.8125 16.8262L14.835 18.8301C14.6592 19.0059 14.5449 19.2432 14.5449 19.5244C14.5449 20.0605 14.9492 20.4561 15.5117 20.4561C15.7578 20.4561 15.9951 20.3594 16.2061 20.1572L21.998 14.3652C22.2002 14.1719 22.3145 13.9082 22.3145 13.6445Z",
    fill: "#007AFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArroRightGo);
export default __webpack_public_path__ + "static/media/arro_right_go.41698ab244f0e0bcf8fca6cb3c940cc9.svg";
export { ForwardRef as ReactComponent };